import { colors } from '../../../../../../../colorVars';
import { Body4 } from '../../../../../../atomic/text/Text'
import { OptionChainsCalls } from './OptionChainsCalls'
import { OptionChainsPuts } from './OptionChainsPuts'
import style from './OptionChainsTable.module.css';


export const ChainsTable = () => {
  return (
    <table className={style.table}>
    <thead>
      <tr>
        <th>
          <Body4 color={colors.lightGrey}>Type</Body4>
        </th>
        <th>
          <Body4 color={colors.lightGrey}>Strike</Body4>
        </th>
        <th>
          <Body4 color={colors.lightGrey}>Date</Body4>
        </th>
      </tr>
    </thead>
    <tbody className={style.tbody}>
      <OptionChainsCalls />
      <OptionChainsPuts />
    </tbody>
  </table>
  )
}

